import React from 'react';
const TabsContext = /*#__PURE__*/React.createContext({});
export default TabsContext;